module.exports = __webpack_public_path__ + "static/media/9.e98ef6d1.jpg";